export default "__VITE_ASSET__0eAJFzJh__"